import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { startAddingAccount } from '../actions/internalActions';
import { accountConnected } from 'owa-accounts-service';
import { accountErrorReferral } from '../actions/publicActions';
import { now } from 'owa-datetime';

mutator(startAddingAccount, () => {
    getStore().connectAccountAttempted = true;
});

mutator(accountErrorReferral, actionMessage => {
    getStore().accountErrorReferralAccounts = actionMessage.userIdentites;
});

mutator(accountConnected, actionMessage => {
    getStore().editorSessionAddedAccounts.push(actionMessage.userIdentity);
    getStore().owaSessionAddedAccountsTimestamps.set(actionMessage.userIdentity, now());
});
